{
  "familyId": "MET-GEW-WEGEN",
  "questions": [
    {
      "id": "MET-GEW-WEGEN-001",
      "familyId": "MET-GEW-WEGEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_wegen",
      "questionType": "multiple_choice",
      "question": "Een weegschaal staat in evenwicht. Aan de ene kant liggen 3 gewichten van 100 gram. Hoeveel weegt het voorwerp aan de andere kant?",
      "context": null,
      "options": ["300 gram", "30 gram", "3 gram", "1.000 gram"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "weighScale",
          "showWhen": "wrong",
          "data": {
            "leftWeight": 300,
            "rightWeight": 300,
            "leftLabel": "3 × 100 g",
            "rightLabel": "Voorwerp",
            "unit": "g",
            "label": "Evenwicht: beide kanten wegen even zwaar"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Evenwicht op de weegschaal",
            "content": "Als een weegschaal in evenwicht staat, wegen beide kanten even zwaar. Tel de gewichten op: 3 × 100 gram = 300 gram. Evenwicht = zelfde gewicht aan beide kanten.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wegen_evenwicht_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "Als een weegschaal in evenwicht staat, wegen beide kanten even zwaar. Aan de ene kant: 3 × 100 gram = 300 gram. Dus het voorwerp weegt ook 300 gram. Waarom? Evenwicht betekent dat de zwaartekracht aan beide kanten gelijk trekt — als één kant zwaarder was, zou die kant naar beneden zakken.",
        "solutionSteps": [
          "Lees af: 3 gewichten van 100 gram aan één kant",
          "Bereken het totaal: 3 × 100 = 300 gram",
          "Evenwicht = beide kanten even zwaar, dus het voorwerp weegt 300 gram"
        ],
        "distractorExplanations": {
          "0": "Correct! 3 × 100 gram = 300 gram. Evenwicht betekent dat beide kanten even zwaar zijn.",
          "1": "Je dacht waarschijnlijk dat elk gewicht 10 gram was. Maar elk gewicht is 100 gram, niet 10. Dus: 3 × 100 = 300 gram. Onthoud: lees goed af hoeveel elk gewicht weegt.",
          "2": "Je dacht waarschijnlijk dat elk gewicht 1 gram was. Maar elk gewicht is 100 gram. Dus: 3 × 100 = 300 gram, niet 3 gram. Onthoud: kijk naar het getal op het gewicht.",
          "3": "Je dacht waarschijnlijk dat je de gewichten bij elkaar moet optellen én vermenigvuldigen. Maar 3 × 100 = 300 gram, niet 1.000 gram. 1.000 gram is 1 kilogram — veel te zwaar."
        }
      }
    },
    {
      "id": "MET-GEW-WEGEN-002",
      "familyId": "MET-GEW-WEGEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_wegen",
      "questionType": "multiple_choice",
      "question": "Op een weegschaal ligt een appel. De weegschaal wijst naar 150 gram. Je legt er nog een appel bij van 120 gram. Wat wijst de weegschaal nu?",
      "context": null,
      "options": ["270 gram", "30 gram", "150 gram", "120 gram"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gewichten optellen",
            "content": "Als je iets erbij legt, tel je de gewichten op. 150 + 120 = 270 gram. Erbij = optellen, eraf = aftrekken.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wegen_optellen",
      "variantIndex": 2,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "Je telt de gewichten op: 150 gram + 120 gram = 270 gram. De weegschaal wijst nu naar 270 gram. Waarom optellen? Omdat je iets erbij legt — de weegschaal moet nu meer gewicht dragen.",
        "solutionSteps": [
          "Eerste appel: 150 gram",
          "Tweede appel erbij: 120 gram",
          "Tel op: 150 + 120 = 270 gram"
        ],
        "distractorExplanations": {
          "0": "Correct! 150 + 120 = 270 gram. Erbij leggen = optellen.",
          "1": "Je dacht waarschijnlijk dat je moet aftrekken. Maar je legt er een appel BIJ, dus tel je op: 150 + 120 = 270 gram. Onthoud: erbij = optellen, eraf = aftrekken.",
          "2": "Je dacht waarschijnlijk dat de weegschaal niet verandert. Maar er liggen nu twee appels op: 150 + 120 = 270 gram. Onthoud: meer gewicht = hogere aanwijzing.",
          "3": "Je dacht waarschijnlijk dat alleen de tweede appel telt. Maar de eerste appel ligt er nog steeds op! Samen: 150 + 120 = 270 gram."
        }
      }
    },
    {
      "id": "MET-GEW-WEGEN-003",
      "familyId": "MET-GEW-WEGEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_wegen",
      "questionType": "multiple_choice",
      "question": "Een tas weegt 2 kg. Je stopt er een boek van 400 gram in. Hoeveel weegt de tas nu?",
      "context": null,
      "options": ["2.400 gram", "2.400 kg", "1.600 gram", "2 kg"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gemengde eenheden",
            "content": "Reken eerst om naar dezelfde eenheid!\n1 kg = 1.000 gram\n2 kg = 2.000 gram\nDan optellen: 2.000 + 400 = 2.400 gram",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wegen_optellen_gemengde_eenheden",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Eerst alles in dezelfde eenheid: 2 kg = 2.000 gram. Dan optellen: 2.000 + 400 = 2.400 gram. De tas weegt nu 2.400 gram (= 2,4 kg). Waarom omrekenen? Je kunt alleen optellen als de eenheden hetzelfde zijn — anders vergelijk je appels met peren!",
        "solutionSteps": [
          "Reken om naar dezelfde eenheid: 2 kg = 2.000 gram",
          "Tel op: 2.000 + 400 = 2.400 gram",
          "Controleer de eenheid in het antwoord: 2.400 gram (niet kg!)"
        ],
        "distractorExplanations": {
          "0": "Correct! 2 kg = 2.000 g, plus 400 g = 2.400 g. Goed omgerekend naar dezelfde eenheid!",
          "1": "Je dacht waarschijnlijk dat het antwoord in kilogram is. Maar 2.400 kg is veel te zwaar (dat is 2,4 ton — zo zwaar als een auto!). Het antwoord is 2.400 gram. Onthoud: let op de eenheid.",
          "2": "Je dacht waarschijnlijk dat je moet aftrekken. Maar je stopt het boek erin, dus tel je op: 2.000 + 400 = 2.400 gram. Onthoud: erin = optellen, eruit = aftrekken.",
          "3": "Je dacht waarschijnlijk dat het gewicht niet verandert. Maar met het boek erbij is het 2.000 + 400 = 2.400 gram. Onthoud: meer erin = zwaarder."
        }
      }
    },
    {
      "id": "MET-GEW-WEGEN-004",
      "familyId": "MET-GEW-WEGEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_wegen",
      "questionType": "multiple_choice",
      "question": "Een weegschaal staat in evenwicht. Links liggen 2 gewichten van 500 gram. Rechts liggen 4 gewichten van hetzelfde gewicht. Hoe zwaar is elk gewicht rechts?",
      "context": null,
      "options": ["250 gram", "500 gram", "333 gram (afgerond)", "1.000 gram"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "weighScale",
          "data": {
            "leftWeight": 1000,
            "rightWeight": 1000,
            "leftLabel": "2 × 500 g",
            "rightLabel": "4 × ? g",
            "unit": "g",
            "showQuestion": true,
            "label": "De weegschaal staat in evenwicht"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdelen bij evenwicht",
            "content": "Stap 1: Bereken het totaal aan één kant: 2 × 500 = 1.000 gram\nStap 2: Evenwicht = andere kant is hetzelfde: 1.000 gram\nStap 3: Deel door het aantal gewichten: 1.000 ÷ 4 = 250 gram",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wegen_evenwicht_verdelen",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Links: 2 × 500 gram = 1.000 gram. De weegschaal staat in evenwicht, dus rechts is ook 1.000 gram. Rechts zijn 4 gewichten: 1.000 ÷ 4 = 250 gram per gewicht. Waarom delen? Omdat de 4 gewichten samen 1.000 gram moeten zijn, en ze zijn allemaal even zwaar.",
        "solutionSteps": [
          "Bereken links: 2 × 500 = 1.000 gram",
          "Evenwicht: rechts is ook 1.000 gram",
          "Verdeel over 4 gewichten: 1.000 ÷ 4 = 250 gram per gewicht",
          "Controleer: 4 × 250 = 1.000 gram ✓"
        ],
        "distractorExplanations": {
          "0": "Correct! Links: 2 × 500 = 1.000 gram. Rechts: 1.000 ÷ 4 = 250 gram per gewicht. Controleer: 4 × 250 = 1.000 ✓",
          "1": "Je dacht waarschijnlijk dat elk gewicht rechts ook 500 gram is. Maar dan zou rechts 4 × 500 = 2.000 gram zijn — dat is dubbel zoveel als links (1.000 gram). Onthoud: evenwicht = zelfde totaal, niet zelfde gewicht per stuk.",
          "2": "Je dacht waarschijnlijk dat je door 3 moet delen. Maar er liggen 4 gewichten rechts, niet 3. Dus: 1.000 ÷ 4 = 250 gram. Onthoud: tel goed hoeveel gewichten er zijn.",
          "3": "Je dacht waarschijnlijk dat elk gewicht 1.000 gram is. Maar dan zou rechts 4 × 1.000 = 4.000 gram zijn — veel te zwaar! Het totaal rechts moet 1.000 gram zijn: 1.000 ÷ 4 = 250 gram."
        }
      }
    },
    {
      "id": "MET-GEW-WEGEN-005",
      "familyId": "MET-GEW-WEGEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_wegen",
      "questionType": "fill_in",
      "question": "Een pakje boter weegt 250 gram. Hoeveel pakjes heb je nodig voor precies 1 kilogram? Typ het aantal.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["4", "4 pakjes", "vier"],
        "caseSensitive": false,
        "placeholder": "... pakjes"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoeveel passen erin?",
            "content": "1 kilogram = 1.000 gram\nDeel het totaal door het gewicht per stuk:\n1.000 ÷ 250 = 4 pakjes\nControleer: 4 × 250 = 1.000 ✓",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wegen_verdelen_kg",
      "variantIndex": 5,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "1 kilogram = 1.000 gram. 1.000 ÷ 250 = 4. Je hebt 4 pakjes van 250 gram nodig om 1 kilogram te maken. Waarom delen? Omdat je wilt weten hoeveel keer 250 gram in 1.000 gram past. Controleer: 4 × 250 = 1.000 gram = 1 kg ✓",
        "solutionSteps": [
          "Reken om: 1 kilogram = 1.000 gram",
          "Deel: 1.000 ÷ 250 = 4 pakjes",
          "Controleer: 4 × 250 = 1.000 gram = 1 kg ✓"
        ]
      }
    },
    {
      "id": "MET-GEW-WEGEN-006",
      "familyId": "MET-GEW-WEGEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_wegen",
      "questionType": "multiple_choice",
      "question": "Op een balansweegschaal liggen links 5 gewichten van 200 gram. Rechts ligt een zak rijst. De weegschaal staat in evenwicht. Hoeveel weegt de zak rijst?",
      "context": null,
      "options": ["1.000 gram", "1.200 gram", "200 gram", "500 gram"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "weighScale",
          "data": {
            "leftWeight": 1000,
            "rightWeight": 1000,
            "leftLabel": "5 × 200 g",
            "rightLabel": "Zak rijst",
            "unit": "g",
            "label": "Lees de weegschaal af"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Evenwicht aflezen",
            "content": "Evenwicht = beide kanten even zwaar. Links: 5 × 200 = 1.000 gram. Dus de zak rijst weegt ook 1.000 gram (= 1 kg).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wegen_evenwicht_aflezen",
      "variantIndex": 6,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "Links: 5 × 200 gram = 1.000 gram. De weegschaal staat in evenwicht, dus rechts is ook 1.000 gram. De zak rijst weegt 1.000 gram (= 1 kg). Onthoud: evenwicht betekent dat beide kanten even zwaar zijn.",
        "solutionSteps": [
          "Bereken links: 5 × 200 = 1.000 gram",
          "Evenwicht: rechts is ook 1.000 gram",
          "De zak rijst weegt 1.000 gram = 1 kg"
        ],
        "distractorExplanations": {
          "0": "Goed! 5 × 200 = 1.000 gram. Evenwicht = beide kanten even zwaar.",
          "1": "Je dacht waarschijnlijk dat je 200 × 6 moet rekenen. Maar er liggen 5 gewichten, niet 6. 5 × 200 = 1.000 gram.",
          "2": "Je dacht waarschijnlijk dat de zak rijst net zo zwaar is als één gewicht. Maar de zak is zo zwaar als alle gewichten samen: 5 × 200 = 1.000 gram.",
          "3": "Je dacht waarschijnlijk dat je het aantal gewichten en het gewicht per stuk optelt: 5 + 200 = 205? Of dat het 500 is? 5 × 200 = 1.000 gram. Onthoud: vermenigvuldigen, niet optellen."
        }
      }
    },
    {
      "id": "MET-GEW-WEGEN-007",
      "familyId": "MET-GEW-WEGEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_wegen",
      "questionType": "fill_in",
      "question": "Op een balansweegschaal liggen links een gewicht van 500 gram en een gewicht van 250 gram. Rechts ligt een pot honing. De weegschaal staat in evenwicht. Hoeveel gram weegt de pot honing? Typ je antwoord.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["750", "750 gram", "750 g", "750g"],
        "caseSensitive": false,
        "placeholder": "... gram"
      },
      "stimulusAids": [
        {
          "type": "weighScale",
          "data": {
            "leftWeight": 750,
            "rightWeight": 750,
            "leftLabel": "500 g + 250 g",
            "rightLabel": "Pot honing",
            "unit": "g",
            "label": "De weegschaal staat in evenwicht"
          }
        }
      ],
      "supportAids": [
        {
          "type": "weighScale",
          "showWhen": "wrong",
          "data": {
            "leftWeight": 750,
            "rightWeight": 750,
            "leftLabel": "500 g + 250 g = 750 g",
            "rightLabel": "Pot honing = 750 g",
            "unit": "g",
            "label": "Evenwicht: beide kanten 750 gram"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gewichten optellen bij evenwicht",
            "content": "Tel de gewichten links op: 500 + 250 = 750 gram. Evenwicht = rechts is hetzelfde. Dus de pot honing weegt 750 gram.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wegen_evenwicht_fill",
      "variantIndex": 7,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Links: 500 + 250 = 750 gram. De weegschaal staat in evenwicht, dus de pot honing weegt ook 750 gram. Controleer: 750 = 750 ✓",
        "solutionSteps": [
          "Tel links op: 500 + 250 = 750 gram",
          "Evenwicht: rechts is ook 750 gram",
          "De pot honing weegt 750 gram"
        ]
      }
    },
    {
      "id": "MET-GEW-WEGEN-008",
      "familyId": "MET-GEW-WEGEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_wegen",
      "questionType": "multiple_choice",
      "question": "Een weegschaal staat in evenwicht. Links ligt een steen. Rechts liggen 1 gewicht van 500 gram en 3 gewichten van 100 gram. Hoeveel weegt de steen?",
      "context": null,
      "options": ["800 gram", "600 gram", "500 gram", "1.300 gram"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "weighScale",
          "data": {
            "leftWeight": 800,
            "rightWeight": 800,
            "leftLabel": "Steen",
            "rightLabel": "500 g + 3 × 100 g",
            "unit": "g",
            "label": "Hoeveel weegt de steen?"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gemengde gewichten optellen",
            "content": "Rechts: 500 + (3 × 100) = 500 + 300 = 800 gram. Evenwicht = links is hetzelfde. Dus de steen weegt 800 gram.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wegen_evenwicht_gemengd",
      "variantIndex": 8,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Rechts: 500 gram + (3 × 100 gram) = 500 + 300 = 800 gram. De weegschaal staat in evenwicht, dus de steen weegt ook 800 gram.",
        "solutionSteps": [
          "Bereken rechts: 3 × 100 = 300 gram",
          "Tel op: 500 + 300 = 800 gram",
          "Evenwicht: de steen weegt ook 800 gram"
        ],
        "distractorExplanations": {
          "0": "Goed! 500 + (3 × 100) = 800 gram.",
          "1": "Je dacht waarschijnlijk dat je alleen de 100 gram-gewichten optelt: 500 + 100 = 600. Maar er zijn 3 gewichten van 100 gram: 3 × 100 = 300. Totaal: 500 + 300 = 800 gram.",
          "2": "Je dacht waarschijnlijk dat alleen het grote gewicht telt. Maar je moet alle gewichten optellen: 500 + 300 = 800 gram.",
          "3": "Je dacht waarschijnlijk dat je alles bij elkaar optelt inclusief het aantal: 500 + 3 + 100 + ... Maar je vermenigvuldigt eerst: 3 × 100 = 300, dan 500 + 300 = 800 gram."
        }
      }
    }
  ]
}